import { DeleteButton, Edit, SaveButton, SimpleForm, Toolbar } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";

import RelayEventFormFields, {
  transformRelayEventPayload,
  validateRelayEventForm,
} from "./RelayEventFormFields";

const EditToolbar = () => (
  <Toolbar sx={{ flexWrap: "wrap", gap: 1 }}>
    <SaveButton />
    <DeleteButton mutationMode="pessimistic" confirmTitle="Delete this relay event?" />
  </Toolbar>
);

const RelayEventEdit = () => (
  <Edit mutationMode="optimistic" transform={transformRelayEventPayload}>
    <SimpleForm
      warnWhenUnsavedChanges
      validate={validateRelayEventForm}
      toolbar={<EditToolbar />}
      sx={{ maxWidth: 640, width: "100%" }}
    >
      <RelayEventFormFields />
      <DisplayDateField source="createdAt" label="Created" showTime />
      <DisplayDateField source="updatedAt" label="Updated" showTime />
    </SimpleForm>
  </Edit>
);

export default RelayEventEdit;
